export default function OverlaySettingsModal({
  cols,
  rows,
  pendingOverlayX,
  pendingOverlayY,
  pendingOverlayW,
  pendingOverlayH,
  pendingOverlayOpacity,
  setPendingOverlayX,
  setPendingOverlayY,
  setPendingOverlayW,
  setPendingOverlayH,
  setPendingOverlayOpacity,
  onApply,
  onCancel,
}) {
  return (
    <div className="modal-backdrop">
      <div className="modal settings-modal">
        <div className="modal-header">
          <h2>Image Overlay Settings</h2>
          <button className="icon-btn" onClick={onCancel}>
            Close
          </button>
        </div>
        <div className="modal-body">
          <div className="setting-group">
            <h3>Position (in grid cells)</h3>
            <div className="grid2">
              <label>
                X-Offset:
                <input
                  type="number"
                  value={pendingOverlayX}
                  onChange={(event) => setPendingOverlayX(event.target.value)}
                  min={-cols}
                  max={cols}
                  className="input"
                />
              </label>
              <label>
                Y-Offset:
                <input
                  type="number"
                  value={pendingOverlayY}
                  onChange={(event) => setPendingOverlayY(event.target.value)}
                  min={-rows}
                  max={rows}
                  className="input"
                />
              </label>
            </div>
            <p className="hint">
              Move the image relative to the top-left corner of the grid (0, 0).
            </p>
          </div>

          <hr />

          <div className="setting-group">
            <h3>Size (in grid cells)</h3>
            <div className="grid2">
              <label>
                Width:
                <input
                  type="number"
                  value={pendingOverlayW}
                  onChange={(event) => setPendingOverlayW(event.target.value)}
                  min="1"
                  max={cols * 3}
                  className="input"
                />
              </label>
              <label>
                Height:
                <input
                  type="number"
                  value={pendingOverlayH}
                  onChange={(event) => setPendingOverlayH(event.target.value)}
                  min="1"
                  max={rows * 3}
                  className="input"
                />
              </label>
            </div>
            <p className="hint">
              Resize the image. Setting to {cols}x{rows} snaps it to the grid size.
            </p>
          </div>

          <hr />

          <div className="setting-group">
            <h3>Transparency</h3>
            <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
              Opacity:
              <input
                type="range"
                min={0.05}
                max={1}
                step={0.05}
                value={pendingOverlayOpacity}
                onChange={(event) => setPendingOverlayOpacity(event.target.value)}
                style={{ flexGrow: 1 }}
              />
              <span>{Math.round(pendingOverlayOpacity * 100)}%</span>
            </label>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-primary" onClick={onApply}>
            Apply Overlay Changes
          </button>
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
